import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CustomHttpParamEncoder } from 'app/core/customHttpParamEncoder';
import { IndexAllowedLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/index-allowed-laboratory.view-model';
import { PickerAllowedLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/picker-allowed-laboratory.view-model';
import { ReadAllowedLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/read-allowed-laboratory.view-model';
import { StandardFilter } from 'app/shared/prothesis-base-api-filters/standard-filter';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../configuration.service';
import { ReadServiceBase } from '../../read-service-base';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedLaboratoryService extends ReadServiceBase<
  ReadAllowedLaboratoryViewModel,
  IndexAllowedLaboratoryViewModel,
  StandardFilter
> {
  protected _configurationService: ConfigurationService;

  public constructor() {
    const _configurationService = inject(ConfigurationService);
    const _httpClient = inject(HttpClient);

    super(_httpClient, () => '/authenticated/Laboratory/', _configurationService.ProthesisApiAddress);

    this._configurationService = _configurationService;
  }

  public initializePicker(
    filter: StandardFilter,
    sort: string,
    page: number,
    pageSize: number,
  ): Observable<PickerAllowedLaboratoryViewModel> {
    if (!filter) {
      filter = new StandardFilter();
    }

    const params = new HttpParams({ encoder: new CustomHttpParamEncoder() })
      .set('filter', JSON.stringify(filter))
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('sort', sort);

    return this._httpClient.get<PickerAllowedLaboratoryViewModel>(`${this._actionUrl}InitializePicker`, { params: params });
  }
}
